import { Message } from 'components/JobGenerator/types';
import { removeDashesFromLi } from 'helpers/functions';

export const R_ONE_FIELDS = ['description', 'qualifications', 'responsibilities'] as Array<
    keyof Message
>;

export const getContentValue = (item: Message, isROne: boolean) => {
    const { content } = item;
    if (isROne) {
        const contentValue = R_ONE_FIELDS.reduce((prev, curr) => {
            let value = '';
            const keyValue = item?.[curr];
            if (typeof keyValue === 'string') {
                value = keyValue || '';
            }
            return `${prev}${value}`;
        }, '');
        return removeDashesFromLi(contentValue);
    }

    return removeDashesFromLi(content || '');
};
